import { LoadingButton } from "@mui/lab";
import { Container, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import React from "react";
import * as Yup from "yup";
import cubeApiClient from "../../BusinessObjects/cubeApiService";
import { useQuery } from "react-query";
import { ResourceNames } from "../../Utils/ResourceNames";
import RenderFormNew from "../../Components/Esaedro/RenderForm/RenderFormNew";
import {
  createEmptyObjectFromFormField,
  getFormFields,
} from "../../Utils/EsaedroHelper";

type Props = {};

const ForgotPasswordPage = (props: Props) => {
  const [loading, setLoading] = React.useState(false);

  const formik = useFormik({
    initialValues: {
      emailOrUsername: "",
    },
    validationSchema: Yup.object().shape({
      emailOrUsername: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      sendEmail(values.emailOrUsername);
    },
  });

  const sendEmail = async (emailOrUsername: string) => {
    setLoading(true);

    const service = new cubeApiClient();

    try {
      await service.forgotPassword(emailOrUsername);

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="lg">
      <Typography variant="h6">Password Dimenticata?</Typography>
      <Typography variant="body1">
        Se hai dimenticato la password, inserisco il tuo indirizzo email o il
        tuo nome utente e ti invieremo un link per reimpostare la tua password.{" "}
      </Typography>
      <div className="w-100 d-flex justify-content-center align-items-center mt-5">
        <form className="login-form w-50" onSubmit={formik.handleSubmit}>
          <div className="form-group">
            <TextField
              id="emailOrUsername"
              name="emailOrUsername"
              fullWidth
              variant="filled"
              label={"Email o Username"}
              margin="normal"
              disabled={loading}
              value={formik.values.emailOrUsername}
              onChange={formik.handleChange}
              error={
                formik.touched.emailOrUsername &&
                Boolean(formik.errors.emailOrUsername)
              }
              helperText={
                formik.touched.emailOrUsername && formik.errors.emailOrUsername
              }
              InputProps={{
                disableUnderline: true,
              }}
              style={{
                borderRadius: 20,
              }}
            />
          </div>
          <div className="form-group">
            <LoadingButton
              variant="contained"
              color="primary"
              size="large"
              disableElevation
              fullWidth
              style={{
                marginTop: 32,
                padding: 16,
                fontWeight: "bold",
                borderRadius: 20,
              }}
              type="submit"
              loading={loading}
            >
              <span>Invia</span>
            </LoadingButton>
          </div>
        </form>
      </div>
    </Container>
  );
};

export default ForgotPasswordPage;
